// @flow
import actionCreators from "@modules/reporting/actionCreator";
import { all, call, put, takeEvery } from "redux-saga/effects";
import { push } from "connected-react-router";
import { route } from "@routes/helper";
import type { Action } from "redux-action";
import {
  GetSpotlightTrendsMyReports,
  GetSpotlightTrendsReportData,
} from "@modules/reporting/constants/actions";
import http from "@http";
import type { SpotlightReport } from "@modules/reporting/reducer/types";

type TrendsReportsRequest = $Exact<{
  clientId: string,
}>;

export function* onGetSpotlightTrendsMyReports({
  payload,
}: Action<TrendsReportsRequest>): Generator<*, void, { data: Array<SpotlightReport> }> {
  try {
    if (!payload || !payload.clientId) {
      throw Error("Invalid payload provided");
    }

    const response = yield call(
      http.get,
      `/api/v1/trends/client/${payload.clientId}/trends/spotlight/my-saved-reports`,
    );

    yield put(actionCreators.GetSpotlightTrendsMyReportsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetSpotlightTrendsMyReportsError(e.response));
  }
}

type TrendsReportDataRequest = $Exact<{
  ...TrendsReportsRequest,
  report: SpotlightReport,
  noRedirect?: boolean,
}>;

export function* onGetSpotlightTrendsReportData({
  payload,
}: Action<TrendsReportDataRequest>): Generator<*, void, *> {
  try {
    if (!payload || !payload.clientId || !payload.report) {
      throw Error("Invalid payload provided");
    }

    const response = yield call(
      http.post,
      `/api/v1/trends/client/${payload.clientId}/trends/spotlight`,
      payload.report.filters,
    );

    yield put(
      actionCreators.GetSpotlightTrendsReportDataSuccess({
        details: payload.report,
        reportData: response.data,
      }),
    );

    if (!payload.noRedirect) {
      yield put(push(route("REPORTING_TRENDS_SPOTLIGHT_REPORT", { clientId: payload.clientId })));
    }
  } catch (e) {
    yield put(actionCreators.GetSpotlightTrendsReportDataError(e.response));
  }
}

export function* SpotlightSaga(): Generator<*, void, void> {
  yield all([
    takeEvery(GetSpotlightTrendsMyReports, onGetSpotlightTrendsMyReports),
    takeEvery(GetSpotlightTrendsReportData, onGetSpotlightTrendsReportData),
  ]);
}

export default SpotlightSaga;
